import { Grid, TextField, Typography } from "@mui/material";
import { Box } from "@mui/system";
import * as React from "react";
import UploadComp from "./CustomisedUpload";

export default function KycComp(props) {
  const { fileData, handleFileData, handleInputChange, inputData, handleDelete, watchlist } = props;

  return (
    <>
      <div className="col-lg-12 col-md-12 col-sm-12 col-12 text-white">
        <div className="mb-3">
          <label className="form-label text-white-50">
            Passport Number<span>*</span>
          </label>
          <TextField
            type="text"
            style={{color: "#fff"}}
            className="form-control text-white white-color passportInput"
            name="passportNumber"
            value={inputData.passportNumber}
            onChange={handleInputChange}
            placeholder="Enter Passport Number"
          >
          </TextField>
        </div>
      </div>
      <div className="kycUploadDiv" style={{ display: "flex", justifyContent: "space-between" }}>
        <div className="col-lg-6 col-md-6 col-sm-12 col-12 text-white">
          <div className="mb-3">
            <UploadComp
              label="Passport Front"
              file={fileData.passFront}
              name="passFront"
              handleImageChange={handleFileData}
              buttonText="Front of Passport"
              sx={{
                backgroundColor: "black",
                borderRadius: "0.5rem",
                width: !watchlist ? "95%" : "190%",
                color: "white",
                border: "1px dashed grey",
                height: "4rem",
                textTransform: "none",
                "&:hover": {
                  backgroundColor: `black`,
                },
              }}
              textSize="16px"
              handleDelete={handleDelete}
              xs={6}
            />
          </div>
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12 col-12 text-white">
          <div className="mb-3">
            <UploadComp
              label="Passport Back"
              file={fileData.passBack}
              name="passBack"
              handleImageChange={handleFileData}
              buttonText="Back of Passport"
              sx={{
                backgroundColor: "black",
                borderRadius: "0.5rem",
                width: !watchlist ? "95%" : "190%",
                color: "white",
                border: "1px dashed grey",
                height: "4rem",
                textTransform: "none",
                "&:hover": {
                  backgroundColor: `black`,
                },
              }}
              textSize="16px"
              handleDelete={handleDelete}
              xs={6}
            />
          </div>
        </div>
      </div>
    </>
  );
}
